module.exports = __webpack_public_path__ + "static/media/imagenotfound.312ca80c.png";